import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MiniBannerWidget } from '../../../core/models';
import { environment } from '../../../environments/environment';
import { SvgComponent } from '../svg/svg.component';
import { CmsImagePipe } from '@selfcare/cms';
import { AppRouting } from '@core/enums';

@Component({
  selector: 'sc-mini-banner-widget',
  imports: [CmsImagePipe, SvgComponent, CmsImagePipe],
  templateUrl: './mini-banner-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniBannerWidgetComponent {
  @Input() data: MiniBannerWidget;

  public AppRouting = AppRouting;

  getMobileAppBannerBackground() {
    return (
      this.data.backgroundImage &&
      `linear-gradient(84.59deg, #000000 0.74%, rgba(0, 0, 0, 0) 99.39%), url(${environment.cms.apiUrl}${this.data.backgroundImage.url})`
    );
  }

  getBannerBackground() {
    return (
      this.data.backgroundImage && `url(${environment.cms.apiUrl}${this.data.backgroundImage.url})`
    );
  }
}
